var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Días disponibles","storeName":"Available_days","parentStoreName":"Notifications_cms","parentUrlKey":"spot_id","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"labelBack":"Atrás","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/notifications_cms'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: 'Días disponibles',
        disabled: false,
        href: '#'
      },
    ]},scopedSlots:_vm._u([{key:"available_hours",fn:function({ item }){return _vm._l((item.available_hour),function(available_hour,index){return _c('p',{key:index},[_vm._v(_vm._s(available_hour.hour_from)+" - "+_vm._s(available_hour.hour_to))])})}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }